<div class="gap-md grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4">
  @for (item of activite().activitesAlternatives; track item.id) {
    <app-activite-card [idSequence]="idSequence()" [activite]="item" />
  }
</div>
